import { NavigateFunction } from 'react-router-dom'

const imgAction = (e: any, action: (src: string) => void) => {
  const imgChild = [...e.target.parentElement.children].find((el: any) => el.tagName === 'IMG')
  if (imgChild) {
    action(imgChild.src)
  }
}

export class EditableAreaEventHandlerService {
  public static onClick = (
    // @ts-ignore
    e: MouseEvent<HTMLDivElement, MouseEvent>,
    onImageClicked: (src: string) => void,
    onDownloaderClicked: (src: string) => void,
    navigate: NavigateFunction
  ) => {
    if (e.target && e.target.href) {
      openLink(e, navigate)
    }
    if (
      e.target &&
      e.target.lastChild &&
      e.target.lastChild.getAttribute &&
      e.target.lastChild.getAttribute('link')
    ) {
      window.open(e.target.lastChild.getAttribute('link'))
    }
    const classes = (e.target as any).className
    if (!classes || !classes.includes) {
      return
    }
    if (classes.includes('ck-image__zoom')) {
      imgAction(e, onImageClicked)
    } else if (classes.includes('ck-image__downloader')) {
      imgAction(e, onDownloaderClicked)
    } else if (classes.includes('file-attachment')) {
      const link = document.createElement('a')
      link.href = (e.target as any).getAttribute('file')
      link.target = '_blank'
      link.click()
    } else if (classes.includes('power-point-attachment') || classes.includes('excel-attachment')) {
      const link = document.createElement('a')
      link.href = (e.target as any).children[2].getAttribute('file')
      link.target = '_blank'
      link.click()
    } else if (classes === 'short-block-expand-button') {
      const parent = (e.target as any).parentElement
      if (parent) {
        const root = parent.parentElement
        if (root) {
          const hiddenBlock = parent.parentElement.children[2]
          if (hiddenBlock.classList.contains('short-block-hidden')) {
            hiddenBlock.classList.remove('short-block-hidden')
          } else {
            hiddenBlock.classList.add('short-block-hidden')
          }
          if (parent.classList.contains('expanded')) {
            parent.classList.remove('expanded')
          } else {
            parent.classList.add('expanded')
          }
        }
      }
    }
  }
}

// @ts-ignore
const openLink = (e: MouseEvent<HTMLDivElement, MouseEvent>, navigate: NavigateFunction) => {
  const currentHostName = window.location.hostname
  const hrefHostName = e.target.href.split('/')[2]
  if (hrefHostName === currentHostName) {
    const innerLink = parseInnerLink(e.target.href)
    if (innerLink) {
      navigate(innerLink)
    }
  } else {
    window.open(e.target.href, '_blank')
  }
  e.preventDefault()
}

const parseInnerLink = (url: string) => {
  let resultUrl
  if (url.includes('http://')) {
    resultUrl = url.split('http://')[1].split('/')
    resultUrl.splice(0, 1)
    resultUrl = `/${resultUrl.join('/')}`
  } else if (url.includes('https://')) {
    resultUrl = url.split('https://')[1].split('/')
    resultUrl.splice(0, 1)
    resultUrl = `/${resultUrl.join('/')}`
  }
  return resultUrl
}
